import { LOAD_ORDERS_REQUEST, LOAD_ORDERS_SUCCESS, LOAD_ORDERS_ERROR, LOAD_ORDER_REQUEST, LOAD_ORDER_SUCCESS, LOAD_ORDER_ERROR, } from '../actions/types';
import { addToList, removeFromList, removeFromMap, } from './utils/thunk';
import initialState from '../store/initial-state';
const orders = (
// eslint-disable-next-line default-param-last
state = initialState.orders, action) => {
    switch (action.type) {
        case LOAD_ORDERS_REQUEST: {
            return {
                ...state,
                success: [],
                loading: 'list',
                error: null,
            };
        }
        case LOAD_ORDER_REQUEST: {
            return {
                ...state,
                success: removeFromList({
                    list: state.success,
                    key: action.payload,
                }),
                loading: addToList({
                    list: state.loading,
                    key: action.payload,
                }),
                error: removeFromMap({
                    map: state.error,
                    key: action.payload,
                }),
            };
        }
        case LOAD_ORDERS_SUCCESS: {
            return {
                ...state,
                success: ['list'],
                loading: [],
                data: action.payload.data.reduce((acc, order) => ({ ...acc, [order.number]: order }), {}),
                error: null,
            };
        }
        case LOAD_ORDER_SUCCESS: {
            const order = action.payload.data;
            const { number } = order;
            const data = { ...state.data, [number]: order };
            return {
                ...state,
                data,
                loading: removeFromList({
                    list: state.loading,
                    key: number,
                }),
                success: addToList({
                    list: state.success,
                    key: number,
                }),
                error: removeFromMap({
                    map: state.error,
                    key: number,
                }),
            };
        }
        case LOAD_ORDERS_ERROR: {
            return {
                ...state,
                success: [],
                loading: [],
                data: {},
                error: {
                    list: action.payload,
                },
            };
        }
        case LOAD_ORDER_ERROR: {
            const { number, error } = action.payload;
            return {
                ...state,
                loading: removeFromList({
                    list: state.loading,
                    key: number,
                }),
                success: removeFromList({
                    list: state.success,
                    key: number,
                }),
                error: { ...state.error, [number]: error },
            };
        }
        default:
            return state;
    }
};
export default orders;
